/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';

type ContentContextState = {
  content?: {
    margins: {
      marginTopDesktop: number;
      marginBottomDesktop: number;
      marginTopTablet: number;
      marginBottomTablet: number;
      marginTopMobile: number;
      marginBottomMobile: number;
    };
    accordian: { showAccordian: string };
  };
  trackingService?: any;
  logger?: any;
};

export const ContentContext = createContext<Partial<ContentContextState>>({});
